import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ChatPanelStore } from '../../services/chat-panel.service';
import { StitchyTeaserPanelComponent } from './stitchy-teaser-panel.component';

/** The Free Trial teaser (SBUX-1231), loaded on its first opening as the real panel is (`app-lazy-stitchy-panel`). */
@Component({
  selector: 'app-lazy-stitchy-teaser-panel',
  host: { class: 'contents' },
  imports: [StitchyTeaserPanelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `@defer (when store.isOpen()) {
    <app-stitchy-teaser-panel [style.display]="hidden() ? 'none' : null" />
  }`,
})
export class LazyStitchyTeaserPanelComponent {
  /** The side panel hides a docked teaser with itself, as it hides the real panel. */
  public readonly hidden = input(false);
  protected readonly store = inject(ChatPanelStore);
}
